import { PhasePlaceholder } from '../components/PhasePlaceholder.js';

export function SpendingPage() {
  return (
    <PhasePlaceholder
      title="Költés"
      phase={3}
      criteria={[
        'Egyszeri tétel rögzítése mobilon legfeljebb 3 tappal.',
        'Fix költség ismétlődési szabállyal, megjelenik a havi nézetben.',
        'Havi kimutatás kategóriánként, a tranzakció napi árfolyamán.',
        'Kategóriák bucketekhez rendelve (Költhető / Vésztartalék / Hosszú távú).',
      ]}
    />
  );
}
